import { h } from 'preact'
import { useMemo } from 'preact/hooks'
import cx from '../../shared/classes'
import { Location } from '../../models/location'
import * as style from './style.css'

interface Props {
    location: Location
    isSelected?: boolean
    onClick: () => void
}

const LocationTile: preact.FunctionalComponent<Props> = ({ location, isSelected, onClick }) => {
    const schedulingEnabled = location.onlineSchedulingEnabled

    const cutOffIfTooLong = (word: string, maxLength: number) => {
        if (word.length > maxLength) {
            return word.slice(0, maxLength - 4).concat('...')
        }
        return word
    }

    const addressData: string[] = useMemo(() => {
        const locationTileRows: string[] = []
        const locationStreetRow: string[] = []
        const cityStateRow: string[] = []
        let rowNumber = 0

        locationTileRows[rowNumber++] = location.name || ''

        if (location.street) {
            locationStreetRow.push(cutOffIfTooLong(location.street, 36))
        }

        if (location.street2) {
            locationStreetRow.push(location.street2)
        }

        if (location.unit) {
            locationStreetRow.push(location.unit)
        }

        if (locationStreetRow.length > 0) {
            locationTileRows[rowNumber++] = locationStreetRow.join(' ')
        }

        if (location.city) {
            cityStateRow.push(location.city)
        }

        if (location.state) {
            cityStateRow.push(location.state)
        }

        let cityStateRowString = cityStateRow.join(' ').trim()

        if (location.zip) {
            cityStateRowString = cityStateRowString.concat(`, ${location.zip}`)
        }

        if (cityStateRowString !== '') {
            locationTileRows[rowNumber++] = cityStateRowString
        }

        if (location.phoneNumber) {
            locationTileRows[rowNumber++] = location.phoneNumber
        }

        return locationTileRows
    }, [location])

    return (
        <div
            onClick={onClick}
            class={cx({
                [style.locationTile]: true,
                [style.locationTileSelected]: isSelected && schedulingEnabled,
                [style.locationTileNotAvailable]: !schedulingEnabled,
            })}
        >
            <div
                class={cx({
                    [style.locationNameLabel]: true,
                    [style.locationDataEllipsis]: true,
                })}
            >
                {addressData[0]}
            </div>
            <div class={style.locationData}>{addressData[1] ?? ''}</div>
            <div class={style.locationData}>{addressData[2] ?? ''}</div>
            <div class={style.locationData}>{addressData[3] ?? ''}</div>
            {!schedulingEnabled && (
                <div class={style.locationTileNotAvailableFooter}>
                    <div class={style.footerText}>Online scheduling not available at this location</div>
                </div>
            )}
        </div>
    )
}

export default LocationTile
